import src from "IMAGE";
export default { src, width: 355, height: 411, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
